import { Component } from '@angular/core';

@Component({
  selector: 'app-disclaimer',
  standalone: true,
  imports: [],
  templateUrl:
    './../../../../Presentation/components/disclaimer/disclaimer.component.html',
  styleUrl:
    './../../../../Presentation/components/disclaimer/disclaimer.component.scss',
})
export class DisclaimerComponent {}
